import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface IndexSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coachee"}}
  <div class="container py-5">
    <div class="alert alert-danger" role="alert">
      You are not registered as a coachee. If you believe this is an error,
      please email
      <a href="mailto:v-support@hultashridge.com">v-support@hultashridge.com</a>
    </div>
  </div>
</template> satisfies TOC<IndexSignature>;
